const innerHtml = `
	function initEmbeddedMessaging() {
		try {
			embeddedservice_bootstrap.settings.language = 'en_US';
			window.addEventListener("onEmbeddedMessagingReady", e => {
  			embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
  				"Country" : "US",
  				"Language" : "en_US"
  			});
			embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
				"_firstName": {
				  "value": "",
				  "isEditableByEndUser": true
				},
				"_lastName": {
				  "value": "",
				  "isEditableByEndUser": true
				},
				"_email": {
				  "value": "",
				  "isEditableByEndUser": true
				}
			  });
			});
			embeddedservice_bootstrap.init(
				'00D3X000002q7Lf',
				'In_App_and_Web_Messaging_US',
				'https://atosmedical.my.site.com/ESWInAppandWebMessagi1756286016531',
				{
					scrt2URL: 'https://atosmedical.my.salesforce-scrt.com'
				}
			);
		} catch (err) {
			console.error('Error loading Embedded Messaging: ', err);
		}
	};
`;

const createScript = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = innerHtml;
    script.classList.add('consent-dependent-chatbot');
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.src = 'https://atosmedical.my.site.com/ESWInAppandWebMessagi1756286016531/assets/js/bootstrap.min.js';
    script2.setAttribute('onload', 'initEmbeddedMessaging()');
    script2.classList.add('consent-dependent-chatbot');
    document.head.appendChild(script2);
};

export default createScript;
